import { useRef, useEffect } from "react";
import { StoreFiltersDataLayer } from "@grandvisionhq/fun-store-filters";
const useNoStoresResultsEvent = (filteredResults) => {
  const eventTriggeredRef = useRef(false);
  useEffect(() => {
    if (filteredResults?.results.length === 0 && !eventTriggeredRef.current) {
      StoreFiltersDataLayer.pushStoreFiltersEvent({
        eventName: "store_filters_click",
        interactionType: "no_stores_match_warning"
      });
      eventTriggeredRef.current = true;
    }
    if (filteredResults?.results.length && filteredResults?.results.length > 0) {
      eventTriggeredRef.current = false;
    }
  }, [filteredResults?.results]);
};
export {
  useNoStoresResultsEvent
};
//# sourceMappingURL=use-no-stores-results-event.js.map
